import { isFilterTypeGuard } from '#shared/kpis-perimeter.model.js';
export const FILTER_NODE_ID_LEVEL_SEPARATOR = '##';
const FILTER_NODE_ID_TYPE_SEPARATOR = '=';
export function joinTypeAndKey(node) {
    return `${node.type}${FILTER_NODE_ID_TYPE_SEPARATOR}${node.filterKey}`;
}
export function isFilterTypeAndKey(filter) {
    const typeAndFilterKey = filter.split(FILTER_NODE_ID_TYPE_SEPARATOR);
    const [filterType, filterKey] = typeAndFilterKey;
    return [typeAndFilterKey.length === 2 && filterType && filterKey && isFilterTypeGuard(filterType)].every(Boolean);
}
export function createFilterNodeId({ filterType, filterKey, parentNodeId }) {
    const joinedTypeAndKey = joinTypeAndKey({
        filterKey,
        type: filterType
    });
    if (parentNodeId) {
        return `${parentNodeId}${FILTER_NODE_ID_LEVEL_SEPARATOR}${joinedTypeAndKey}`;
    }
    return joinedTypeAndKey;
}
export function splitFilterNodeId(node) {
    return node
        .split(FILTER_NODE_ID_LEVEL_SEPARATOR)
        .map((typeAndValue) => typeAndValue.split(FILTER_NODE_ID_TYPE_SEPARATOR));
}
export function getFilterTypeAndKeyFromNodeId(node) {
    const splittedNodeId = splitFilterNodeId(node);
    const filter = splittedNodeId[splittedNodeId.length - 1] ?? [];
    const [filterType, filterKey] = filter;
    if (!filterType || !filterKey) {
        throw new Error(`Invalid filter: no filterType or filterKey`);
    }
    if (!isFilterTypeGuard(filterType)) {
        throw new Error(`Retrieved type is not one of AllFilterType: ${filterType}`);
    }
    return { filterType, filterKey };
}
export function extractFilterKeyFromNodeId(node) {
    return getFilterTypeAndKeyFromNodeId(node).filterKey;
}
export function extractFilterTypeFromNodeId(node) {
    return getFilterTypeAndKeyFromNodeId(node).filterType;
}
export function getFilterTypeAndKeyFromNodeIdSafe(node) {
    try {
        return getFilterTypeAndKeyFromNodeId(node);
    }
    catch {
        return null;
    }
}
export function isValidFilterType(node, filterTypes) {
    try {
        const { filterType } = getFilterTypeAndKeyFromNodeId(node);
        return !filterTypes || filterType.includes(filterType);
    }
    catch (_e) {
        return false;
    }
}
export function isEcommerceActivityType(activityTypeNodeId) {
    const { filterKey, filterType } = getFilterTypeAndKeyFromNodeId(activityTypeNodeId);
    return filterType === 'activityType' && filterKey === 'E-Commerce';
}
export const isInStoreActivityType = (activityTypeNodeId) => {
    const { filterKey, filterType } = getFilterTypeAndKeyFromNodeId(activityTypeNodeId);
    return filterType === 'activityType' && filterKey === 'In store';
};
export const isEcommerceAvailable = (storePerimeter, userCountry) => {
    if (!userCountry) {
        return false;
    }
    if (userCountry !== 'FRA' && storePerimeter === 'likeForLike') {
        return false;
    }
    return true;
};
export const isLikeForLikeAvailable = (activityTypes, userCountry) => {
    if (!userCountry) {
        return false;
    }
    const isAllActivityTypeSelected = activityTypes.length === 0;
    if (userCountry !== 'FRA' && (activityTypes.some(isEcommerceActivityType) || isAllActivityTypeSelected)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=filter.utils.js.map